import { combineReducers } from "redux";
import authReducer from "./auth";
import uiReducer from "./ui";
import workspacesReducer from "./workspaces";

export default combineReducers({
    auth: authReducer,
    ui: uiReducer,
    workspaces:workspacesReducer
});